import React, { Component } from 'react'
import './style.css'
import showcase1 from '../../../../assets/images/shop/scblack.jpg';
import showcase2 from '../../../../assets/images/shop/scrosegold.jpg';
import showcase3 from '../../../../assets/images/shop/scdarkgrey.jpg';
import showcase4 from '../../../../assets/images/shop/scearthgrey.jpg';
import showcase5 from '../../../../assets/images/shop/scwhite.jpg';
import showcase6 from '../../../../assets/images/shop/scblue.jpg';

import image1 from '../../../../assets/images/shop/preview1.jpg';
import image3 from '../../../../assets/images/shop/preview2.jpg';
import image4 from '../../../../assets/images/shop/preview3.jpg';

import black from '../../../../assets/images/shop/black.jpg';
import white from '../../../../assets/images/shop/white.jpg';
import pink from '../../../../assets/images/shop/pink.jpg';
import greybrown from '../../../../assets/images/shop/greybrown.jpg';
import darkgrey from '../../../../assets/images/shop/darkgrey.jpg';
import blue from '../../../../assets/images/shop/blue.jpg';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

export default class Home extends Component {
  render() {
    return (
      <div className="flex flex-column">
        <div className="mobile-nav">
          <a className="mobile-logo ml3" href="/shop/icons">Veil</a>
        </div>
        <div className="nav">
          <a className="nav-link" href="#overview">Overview</a>
          <a className="nav-link" href="#colors">Colors</a>
          <a className="nav-link" href="#tutorial">Tutorial</a>
          <a className="nav-link" href="#faq">FAQ</a>
          <a className="nav-link" href="/shop/icons/list">Icon List</a>
        </div>
        <a className="buy-button" href="https://gum.co/antebellum"  onClick={() => {window.fbq('track', 'InitiateCheckout');}}>Purchase - $18</a>
        <Carousel className="mt5 mt5-ns pt2 mb0 mb3-ns" infiniteLoop autoPlay showArrows={true} showStatus={false} swipable={true} showThumbs={false} interval={10000}>
            <div>
              <picture>
                <source data-srcset={showcase1} type="image/jpg" srcSet={showcase1}></source>
                <img className="carousel-images" data-src={showcase1} src={showcase1} alt="something about you"></img>
              </picture>
            </div>
            <div>
              <picture>
                <source data-srcset={showcase2} type="image/jpg" srcSet={showcase2}></source>
                <img className="carousel-images" data-src={showcase2} src={showcase2} alt="something about you"></img>
              </picture>
            </div>

            <div>
              <picture>
                <source data-srcset={showcase3} type="image/jpg" srcSet={showcase3}></source>
                <img className="carousel-images" data-src={showcase3} src={showcase3} alt="something about you"></img>
              </picture>
            </div>

            <div>
              <picture>
                <source data-srcset={showcase4} type="image/jpg" srcSet={showcase4}></source>
                <img className="carousel-images" data-src={showcase4} src={showcase4} alt="something about you"></img>
              </picture>
            </div>

            <div>
              <picture>
                <source data-srcset={showcase5} type="image/jpg" srcSet={showcase5}></source>
                <img className="carousel-images" data-src={showcase5} src={showcase5} alt="something about you"></img>
              </picture>
            </div>

            <div>
              <picture>
                <source data-srcset={showcase6} type="image/jpg" srcSet={showcase6}></source>
                <img className="carousel-images" data-src={showcase6} src={showcase6} alt="something about you"></img>
              </picture>
            </div>
        </Carousel>
        <div className="w-100 mw-100 flex flex-row justify-center landing-top-space mb5-ns mb0">
          <div className="w-10"></div>
          <div className="w-80 child flex flex-column">
            <div className="landing-headline mt3-ns mt0">Veil - iOS 14 Icon Set</div>
            <div className="landing-subhead mt3">A minimal, yet daunting icon set for iOS 14.<br/>Provided in Black, White, Rose Gold, Sky Blue, Earth Grey, and Dark Grey.</div>
            <div className="landing-body flex flex-row flex-wrap mt5-ns mt3">
              <div className="landing-body-items">120+ Icons</div>
              <div className="landing-body-items">6 Color Scheme</div>
              <div className="landing-body-items">6 Wallpapers</div>
              <div className="landing-body-items">Lifetime Updates</div>
            </div>
            <div className="landing-section-head mt5" id="overview">
              Overview
            </div>
            <div className="mt3 mb3 mb5-ns">
              <picture>
                <source data-srcset={image1} type="image/jpg" srcSet={image1}></source>
                <img className="landing-images landing-image-1" data-src={image1} src={image1} alt="something about you"></img>
              </picture>
            </div>
            <div className="mb3 mb5-ns">
              <picture>
                <source data-srcset={image3} type="image/jpg" srcSet={image3}></source>
                <img className="landing-images landing-image-3" data-src={image3} src={image3} alt="something about you"></img>
              </picture>
            </div>
            <div className="mb5">
              <picture>
                <source data-srcset={image4} type="image/jpg" srcSet={image4}></source>
                <img className="landing-images landing-image-4" data-src={image4} src={image4} alt="something about you"></img>
              </picture>
            </div>
            <div className="landing-section-head" id="colors">
              Color Schemes
            </div>
            <div className="landing-color-section flex flex-column">
              <div className="flex flex-row flex-wrap mt3">
                <div className="flex flex-column w-50 pr1 pl1 landing-color-items">
                  <div className="landing-body-items">Black</div>
                  <div className="mb3 mb5-ns mt3">
                    <picture>
                      <source data-srcset={black} type="image/jpg" srcSet={black}></source>
                      <img className="color-images landing-color-image-black" data-src={black} src={black} alt="something about you"></img>
                    </picture>
                  </div>
                </div>
                <div className="flex flex-column w-50 pr1 pl1 landing-color-items">
                  <div className="landing-body-items">White</div>
                  <div className="mb3 mb5-ns mt3">
                    <picture>
                      <source data-srcset={white} type="image/jpg" srcSet={white}></source>
                      <img className="color-images landing-color-image-black" data-src={white} src={white} alt="something about you"></img>
                    </picture>
                  </div>
                </div>
                <div className="flex flex-column w-50 pr1 pl1 landing-color-items">
                  <div className="landing-body-items">Rose Gold</div>
                  <div className="mb3 mb5-ns mt3">
                    <picture>
                      <source data-srcset={pink} type="image/jpg" srcSet={pink}></source>
                      <img className="color-images landing-color-rose-gold" data-src={pink} src={pink} alt="something about you"></img>
                    </picture>
                  </div>
                </div>
                <div className="flex flex-column w-50 pr1 pl1 landing-color-items">
                  <div className="landing-body-items">Sky Blue</div>
                  <div className="mb3 mb5-ns mt3">
                    <picture>
                      <source data-srcset={blue} type="image/jpg" srcSet={blue}></source>
                      <img className="color-images landing-color-blue" data-src={blue} src={blue} alt="something about you"></img>
                    </picture>
                  </div>
                </div>
                <div className="flex flex-column w-50 pr1 pl1 landing-color-items">
                  <div className="landing-body-items">Earth Grey</div>
                  <div className="mb3 mb5-ns mt3">
                    <picture>
                      <source data-srcset={greybrown} type="image/jpg" srcSet={greybrown}></source>
                      <img className="color-images landing-color-grey-brown" data-src={greybrown} src={greybrown} alt="something about you"></img>
                    </picture>
                  </div>
                </div>
                <div className="flex flex-column w-50 pr1 pl1 landing-color-items">
                  <div className="landing-body-items">Dark Grey</div>
                  <div className="mb5 mt3">
                    <picture>
                      <source data-srcset={darkgrey} type="image/jpg" srcSet={darkgrey}></source>
                      <img className="color-images landing-color-dark-grey" data-src={darkgrey} src={darkgrey} alt="something about you"></img>
                    </picture>
                  </div>
                </div>
              </div>
            </div>
            <div className="landing-section-head" id="tutorial">
              Tutorial
            </div>
            <div className="landing-tutorial-section mt3 mb5">
              <iframe className="landing-video" title="tutorial video" width="100%" src="https://www.youtube.com/embed/cH66LWWluVE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div className="landing-section-head" id="faq">
              Before You Buy
            </div>
            <div className="landing-credits mt3 mb5 flex flex-column">
              <ul className="pa0">
                <li>Before <i>iOS version 14.3 b2</i>, custom icons will open the shortcuts app first</li>
                <li className="mt1">Notification badge will not show on the custom icon</li>
                <li className="mt1">Each custom icon should be set manually, you can see how to set up in the instruction video</li>
                <li className="mt1">No manual refunds</li>
              </ul>
            </div>
            <div className="bottom-nav flex flex-column mb5">
              <a className="botton-nav-link pa0 ma0 pb3" href="#overview">Overview</a>
              <a className="botton-nav-link pa0 ma0 pb3" href="#colors">Colors</a>
              <a className="botton-nav-link pa0 ma0 pb3" href="#tutorial">Tutorial</a>
              <a className="botton-nav-link pa0 ma0 pb3" href="#faq">FAQ</a>
              <a className="botton-nav-link pa0 ma0 pb3" href="/shop/icons/list">List</a>
            </div>
          </div>
          <div className="w-10"></div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/IosIcon/Landing/index.jsx